import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { FormikProps } from 'formik';

import { IMap } from '@shared/interfaces';

import { ICountyOptions, TDocFeeStateExclusion } from '../../../interfaces';

export interface IDocFeesTableProps {
  lenderId: string;
  data?: TDocFeeStateExclusion[];
  includeTitleFeeInDeal: boolean;
}

export enum calculationType {
  FlatFee = 1,
  Formula = 2,
}

interface ICondition {
  minimumLoanAmount: number;
  maximumLoanAmount: number;
  maximumFeeAmount: number;
}

export interface IFormulaFields {
  id: string;
  state: string;
  counties: string;
  countyList?: ICountyOptions[];
  countyIds?: string[];
  isDocFee?: boolean;
  condition: ICondition;
  formula: string;
  calculationType: calculationType;
  amount: number;
}

export interface IFormulaProps {
  modalData: IFormulaFields | null,
  handleClose(): void;
  lenderId: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  apiRef: React.MutableRefObject<GridApiPro>;
}

export interface IFormulaVariables {
  lenderVariable: string;
  id: string;
  testValue: number;
}

export interface IFormulaFormProps extends FormikProps<IFormulaFields> {
  varValues: IMap<number>
  handleClose: () => void;
  loading: boolean;
}

export const options = [
  { value: 1, label: 'Flat Fee' },
  { value: 2, label: 'Formula' },
];

export const formulaVariables = [
  {
    lenderVariable: 'Principle or Sales Price',
    id: 'SLPR',
    testValue: 19000
  },
  {
    lenderVariable: 'Amount Financed or Total Amount Financed or Disclosed Amt Financed',
    id: 'AMTFIN',
    testValue: 22000,
  },
  {
    lenderVariable: 'Same as name',
    id: 'RATE',
    testValue: 0.05,
  },
  {
    lenderVariable: 'Same as name',
    id: 'TERM',
    testValue: 45,
  },
  {
    lenderVariable: 'Title Fee',
    id: 'TITLE',
    testValue: 350,
  },
  {
    lenderVariable: 'Default Doc Fee or Total Doc Fees',
    id: 'DOCF',
    testValue: 350,
  },
];

export const formulaExamples = [
  {
    description: '$120 +$3 per month for each month of the scheduled term, MAX $395.',
    formula: 'min((120+3*TERM), 395)'
  },
  {
    description: 'If rate is over 18% and amount financed is less than 25,000 TAF = NO FEE.',
    formula: 'if(RATE>0.18 and AMTFIN<25000, 0, DOCF)'
  },
  {
    description: 'Greater of $250.00 or 1% of Disclosed Amount Financed not to exceed $299',
    formula: 'min(max(0.01*AMTFIN, 250), 299)'
  },
  {
    description: 'Calculation Required: 4% of initial $20K, 2% on remaining principal MAX $395',
    formula: 'min(if(SLPR > 20000,(0.04 * 20000 + 0.02*(SLPR - 20000)), (SLPR * 0.04) ), 395)'
  },
];

export const columnData = [
  {
    name: 'if',
    description: 'Logical if else based function',
    syntax: 'if(condition, ifValue, elseValue)',
  },
  {
    name: 'min',
    description: 'find minimum of two values',
    syntax: 'min(value1, value2)',
  },
  {
    name: 'max',
    description: 'find maximum of two values',
    syntax: 'max(value1, value2)',
  },
];
